import { z } from "zod";

import { createQueryRequestDefinition } from "~/lib/network/definitions/create";

import {
  listTTSModelsResponse,
  listVoicesResponse,
  statusTTSGenerationRequest,
  statusTTSGenerationResponse,
} from "./schemas";

export const listVoicesQuery = createQueryRequestDefinition({
  queryKey: ["voiceover", "voices", "list"],
  host: "cap-srv",
  method: "POST",
  path: "voiceover/tts/voices/list",
  responseSchema: listVoicesResponse,
  paramsSchema: z.object({
    caller: z.enum(["mirage"]).optional(),
  }),
});

export const listTTSModelsQuery = createQueryRequestDefinition({
  queryKey: ["voiceover", "models", "list"],
  host: "cap-srv",
  method: "POST",
  path: "voiceover/tts/models/list",
  responseSchema: listTTSModelsResponse,
  paramsSchema: z.object({
    caller: z.enum(["mirage"]).optional(),
  }),
});

export const voiceoverGenerationStatusQuery = createQueryRequestDefinition({
  queryKey: ["voiceover", "status", "tts", "status"],
  host: "cap-srv",
  method: "POST",
  path: "voiceover/tts/generate/status",
  paramsSchema: statusTTSGenerationRequest,
  responseSchema: statusTTSGenerationResponse,
  analytics: {
    level: "custom",
    shouldLogRequest(status, _, response) {
      // logs failures and non-pending states
      if (status === "cancel") {
        return false;
      }

      return (
        status === "fail" || (response?.state !== "PROCESSING" && response?.state !== "QUEUED")
      );
    },
  },
}).withPolling({
  swallowAbortErrors: true,
  determinePollingStatus(result, resultCreator) {
    if (result.state === "COMPLETE") {
      return resultCreator.done(result);
    } else if (result.state === "QUEUED" || result.state === "PROCESSING") {
      return resultCreator.pending(result);
    }
    return resultCreator.failed(result);
  },
});

export type VoiceoverGenerationResult = Awaited<
  ReturnType<typeof voiceoverGenerationStatusQuery.usePollingQuery>
>["currentResult"];
